import React from 'react';
import { FaCloud, FaShoppingCart, FaTools, FaBrain } from 'react-icons/fa';

const About = () => {
  return (
    <section id="apropos" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="section-title mb-12">À propos</h2>
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            {/* Features grid (8 items total: 4 + 4) */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {[
                { icon: <FaCloud />, title: 'Gestion centralisée', desc: "Vos demandes et fichiers centralisés et sécurisés." },
                { icon: <FaShoppingCart />, title: 'Commande simple', desc: "Devis rapide et validation en quelques clics." },
                { icon: <FaTools />, title: 'Outils & finitions', desc: "Sablage, pliage, peinture et traitement adaptés." },
                { icon: <FaBrain />, title: 'Conseil design', desc: "Accompagnement technique et esthétique sur mesure." },
                { icon: <FaCloud />, title: 'Claustras & grilles', desc: "Réalisation sur mesure de motifs et protections décoratives." },
                { icon: <FaTools />, title: 'Portails & garde-corps', desc: "Robustesse et finitions soignées pour l’extérieur." },
                { icon: <FaShoppingCart />, title: 'Rampes & structures', desc: "Fabrication précise et adaptée à votre usage." },
                { icon: <FaBrain />, title: 'Solutions durables', desc: "Matériaux adaptés et conseils pérennité." }
              ].map((f) => (
                <div key={f.title} className="flex items-start gap-4">
                  <div className="h-12 w-12 rounded-full bg-gray-100 text-gray-700 flex items-center justify-center text-xl shrink-0">
                    {f.icon}
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">{f.title}</div>
                    <p className="text-sm text-gray-600 leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {["/images/hero.jpg", "/images/hero11.jpg", "/images/hero12.jpg", "/images/hero13.jpg"].map((src) => (
              <div key={src} className="rounded-xl overflow-hidden shadow-md border border-gray-200 transform transition-transform duration-300 hover:scale-[1.02]">
                <img src={src} alt="Réalisation découpe laser" className="w-full h-44 sm:h-56 object-cover" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;


